/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../../../../../../addons/shared/first_party_addons';
import '../../../../../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "addons": {
                            "nested": {
                              "OpenTickets": {
                                "fields": {
                                  "isEnabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "usesOpenTicketsMenuAsHomeScreen": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "usesPredefinedTickets": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "sendsDailyDeletionEmail": {
                                    "type": "bool",
                                    "id": 4,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "firstPartyAddon": {
                                    "type": ".squareup.addons.shared.FirstPartyAddon",
                                    "id": 5,
                                    "rule": "optional",
                                    "options": {
                                      "default": "OPEN_TICKETS"
                                    }
                                  },
                                  "isPreAuthEnabled": {
                                    "type": "bool",
                                    "id": 6,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "minimumPreAuthAmount": {
                                    "type": ".squareup.common.Money",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "isSendAndStayEnabled": {
                                    "type": "bool",
                                    "id": 8,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.addons?.nested?.OpenTickets) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE OpenTickets @ squareup/devicesettings/profiles/v2/model/settings/addons/open_tickets.proto at 20:1
 */
export const OpenTickets = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.addons.OpenTickets');
fixType(OpenTickets);
Builder.createAndAttachToType(OpenTickets);